export interface Currency {
  code: string;
  name: string;
  symbol: string;
  symbolNative?: string;
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', name: 'US Dollar', symbol: '$', symbolNative: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€', symbolNative: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£', symbolNative: '£' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥', symbolNative: '¥' },
  { code: 'CNY', name: 'Chinese Yuan', symbol: '¥', symbolNative: '¥' },
  { code: 'SAR', name: 'Saudi Riyal', symbol: 'ر.س', symbolNative: 'ر.س' },
  { code: 'AED', name: 'UAE Dirham', symbol: 'د.إ', symbolNative: 'د.إ' },
  { code: 'EGP', name: 'Egyptian Pound', symbol: 'ج.م', symbolNative: 'ج.م' },
  { code: 'KWD', name: 'Kuwaiti Dinar', symbol: 'د.ك', symbolNative: 'د.ك' },
  { code: 'QAR', name: 'Qatari Riyal', symbol: 'ر.ق', symbolNative: 'ر.ق' },
  { code: 'BHD', name: 'Bahraini Dinar', symbol: 'د.ب', symbolNative: 'د.ب' },
  { code: 'OMR', name: 'Omani Rial', symbol: 'ر.ع', symbolNative: 'ر.ع' },
  { code: 'JOD', name: 'Jordanian Dinar', symbol: 'د.أ', symbolNative: 'د.أ' },
  { code: 'LBP', name: 'Lebanese Pound', symbol: 'ل.ل', symbolNative: 'ل.ل' },
  { code: 'IQD', name: 'Iraqi Dinar', symbol: 'ع.د', symbolNative: 'ع.د' },
  { code: 'MAD', name: 'Moroccan Dirham', symbol: 'د.م.', symbolNative: 'د.م.' },
  { code: 'TND', name: 'Tunisian Dinar', symbol: 'د.ت', symbolNative: 'د.ت' },
  { code: 'DZD', name: 'Algerian Dinar', symbol: 'د.ج', symbolNative: 'د.ج' },
  { code: 'LYD', name: 'Libyan Dinar', symbol: 'ل.د', symbolNative: 'ل.د' },
  { code: 'SDG', name: 'Sudanese Pound', symbol: 'ج.س.', symbolNative: 'ج.س.' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: 'CA$', symbolNative: '$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', symbolNative: '$' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', symbolNative: '$' },
  { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', symbolNative: 'Fr' },
  { code: 'SEK', name: 'Swedish Krona', symbol: 'SEK', symbolNative: 'kr' },
  { code: 'NOK', name: 'Norwegian Krone', symbol: 'NOK', symbolNative: 'kr' },
  { code: 'DKK', name: 'Danish Krone', symbol: 'DKK', symbolNative: 'kr' },
  { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', symbolNative: '$' },
  { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', symbolNative: '$' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹', symbolNative: '₹' },
  { code: 'PKR', name: 'Pakistani Rupee', symbol: '₨', symbolNative: '₨' },
  { code: 'BDT', name: 'Bangladeshi Taka', symbol: '৳', symbolNative: '৳' },
  { code: 'LKR', name: 'Sri Lankan Rupee', symbol: 'Rs', symbolNative: 'රු' },
  { code: 'NPR', name: 'Nepalese Rupee', symbol: 'Rs', symbolNative: 'रू' },
  { code: 'MYR', name: 'Malaysian Ringgit', symbol: 'RM', symbolNative: 'RM' },
  { code: 'IDR', name: 'Indonesian Rupiah', symbol: 'Rp', symbolNative: 'Rp' },
  { code: 'THB', name: 'Thai Baht', symbol: '฿', symbolNative: '฿' },
  { code: 'VND', name: 'Vietnamese Dong', symbol: '₫', symbolNative: '₫' },
  { code: 'PHP', name: 'Philippine Peso', symbol: '₱', symbolNative: '₱' },
  { code: 'KRW', name: 'South Korean Won', symbol: '₩', symbolNative: '₩' },
  { code: 'TWD', name: 'New Taiwan Dollar', symbol: 'NT$', symbolNative: '$' },
  { code: 'MXN', name: 'Mexican Peso', symbol: 'MX$', symbolNative: '$' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', symbolNative: 'R$' },
  { code: 'ARS', name: 'Argentine Peso', symbol: 'AR$', symbolNative: '$' },
  { code: 'CLP', name: 'Chilean Peso', symbol: 'CL$', symbolNative: '$' },
  { code: 'COP', name: 'Colombian Peso', symbol: 'CO$', symbolNative: '$' },
  { code: 'PEN', name: 'Peruvian Sol', symbol: 'S/', symbolNative: 'S/' },
  { code: 'RUB', name: 'Russian Ruble', symbol: '₽', symbolNative: '₽' },
  { code: 'TRY', name: 'Turkish Lira', symbol: '₺', symbolNative: '₺' },
  { code: 'UAH', name: 'Ukrainian Hryvnia', symbol: '₴', symbolNative: '₴' },
  { code: 'PLN', name: 'Polish Zloty', symbol: 'zł', symbolNative: 'zł' },
  { code: 'CZK', name: 'Czech Koruna', symbol: 'Kč', symbolNative: 'Kč' },
  { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft', symbolNative: 'Ft' },
  { code: 'RON', name: 'Romanian Leu', symbol: 'lei', symbolNative: 'lei' },
  { code: 'BGN', name: 'Bulgarian Lev', symbol: 'лв', symbolNative: 'лв' },
  { code: 'HRK', name: 'Croatian Kuna', symbol: 'kn', symbolNative: 'kn' },
  { code: 'ISK', name: 'Icelandic Króna', symbol: 'kr', symbolNative: 'kr' },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R', symbolNative: 'R' },
  { code: 'NGN', name: 'Nigerian Naira', symbol: '₦', symbolNative: '₦' },
  { code: 'KES', name: 'Kenyan Shilling', symbol: 'Ksh', symbolNative: 'Ksh' },
  { code: 'GHS', name: 'Ghanaian Cedi', symbol: '₵', symbolNative: '₵' },
  { code: 'UGX', name: 'Ugandan Shilling', symbol: 'USh', symbolNative: 'USh' },
  { code: 'TZS', name: 'Tanzanian Shilling', symbol: 'TSh', symbolNative: 'TSh' },
  { code: 'RWF', name: 'Rwandan Franc', symbol: 'RF', symbolNative: 'RF' },
  { code: 'XOF', name: 'West African CFA Franc', symbol: 'CFA', symbolNative: 'CFA' },
  { code: 'XAF', name: 'Central African CFA Franc', symbol: 'FCFA', symbolNative: 'FCFA' },
  { code: 'IRR', name: 'Iranian Rial', symbol: '﷼', symbolNative: '﷼' },
  { code: 'AFN', name: 'Afghan Afghani', symbol: '؋', symbolNative: '؋' },
  { code: 'GEL', name: 'Georgian Lari', symbol: '₾', symbolNative: '₾' },
  { code: 'AMD', name: 'Armenian Dram', symbol: '֏', symbolNative: '֏' },
  { code: 'AZN', name: 'Azerbaijani Manat', symbol: '₼', symbolNative: '₼' },
  { code: 'KZT', name: 'Kazakhstani Tenge', symbol: '₸', symbolNative: '₸' },
  { code: 'UZS', name: 'Uzbekistani Som', symbol: 'soʻm', symbolNative: 'soʻm' },
];

const CURRENCY_MAP: Record<string, Currency> = Object.fromEntries(
  CURRENCIES.map((c) => [c.code, c])
);

/** Returns the symbol for a currency code (e.g. 'USD' → '$', 'SAR' → 'ر.س', 'EGP' → 'ج.م') */
export function getCurrencySymbol(code: string): string {
  return CURRENCY_MAP[code]?.symbol ?? code;
}

/** Returns the full Currency object for a code, or undefined if not found */
export function getCurrency(code: string): Currency | undefined {
  return CURRENCY_MAP[code];
}

/** Formats a price with the currency symbol (e.g. formatPrice(10.5, 'USD') → '$ 10.50') */
export function formatPrice(amount: number, currencyCode: string = 'USD'): string {
  const symbol = getCurrencySymbol(currencyCode);
  return `${symbol} ${amount.toFixed(2)}`;
}
